import { AppShell } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { LIGHT_GREY } from '../../const/constants';
import { useAuth } from '../../hooks/useAuth';
import { Navbar } from './Navbar';
import { UnauthNavbar } from './UnauthNavbar';

interface NavbarProps {
	children: React.ReactNode;
}

export function Shell({ children }: NavbarProps) {
	const auth = useAuth();
	const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
	const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);

	return auth.isAuth() ? (
		<AppShell
			padding={'md'}
			header={{ height: 60 }}
			navbar={{
				width: 300,
				breakpoint: 'sm',
				collapsed: {
					mobile: !mobileOpened,
					desktop: !desktopOpened,
				},
			}}
		>
			<Navbar
				isOpenDesktop={desktopOpened}
				isOpenMobile={mobileOpened}
				toggleNavbarDesktop={toggleDesktop}
				toggleNavbarMobile={toggleMobile}
			/>
			{/* <AppShell.Main className={css.removeMainPadding}> */}
			<AppShell.Main bg={LIGHT_GREY}>{children}</AppShell.Main>
		</AppShell>
	) : (
		<AppShell
			padding={'md'}
			header={{ height: 60 }}
			navbar={{
				width: 300,
				breakpoint: 'sm',
				collapsed: {
					mobile: true,
					desktop: true,
				},
			}}
		>
			<UnauthNavbar />
			<AppShell.Main bg={'white'}>
				{/* <AppShell.Main className={css.removeMainPadding}> */}
				{children}
			</AppShell.Main>
		</AppShell>
	);
}
